import { useEffect, useState } from 'react';
import Banner_otherpages from '../../__public/__sections/_Banner_otherpages';
import image from '../../../assets/images/otherpages/onboarding.jpg';
import cocacola from '../../../assets/images/careers_and_blog/cocacola.jpg';
import { Link } from 'react-router-dom';
import Header from '../../__public/__layouts/Header';
import { UilBriefcase, UilComment, UilEye, UilSearch } from '@iconscout/react-unicons';
import Map from '../../__public/__sections/_Map';

const Blog = (props) => {
    const [activeFilter, setActiveFilter] = useState('All');
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [pinInput, setPinInput] = useState('');
    const [pinError, setPinError] = useState('');

    const CORRECT_PIN = '879316'; 

    useEffect(() => {
        document.title = `${props.company} — Blog`;
        // Check if user was already authenticated in this session
        const authenticated = sessionStorage.getItem('onboarding-authenticated');
        if (authenticated === 'true') {
            setIsAuthenticated(true);
        }
    }, []);

    const handlePinSubmit = (e) => {
        e.preventDefault();
        if (pinInput === CORRECT_PIN) {
            setIsAuthenticated(true);
            setPinError('');
            // Store authentication in session storage (will be cleared when browser is closed)
            sessionStorage.setItem('onboarding-authenticated', 'true');
        } else {
            setPinError('Invalid PIN. Please try again.');
            setPinInput('');
        }
    };

    // PIN entry form
    if (!isAuthenticated) {
        return (
            <>
                <Header />
                <div className="sections pt-20">
                    <div className="flex items-center justify-center min-h-[60vh]">
                        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full mx-4">
                            <h2 className="text-2xl font-bold text-center mb-6 text-[#f34c02]">
                                Access Required
                            </h2>
                            <p className="text-gray-600 text-center mb-6">
                                Please enter your PIN to access the onboarding materials.
                            </p>
                            <form onSubmit={handlePinSubmit}>
                                <div className="mb-4">
                                    <input
                                        type="password"
                                        value={pinInput}
                                        onChange={(e) => setPinInput(e.target.value)}
                                        placeholder="Enter PIN"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#f34c02] text-center text-lg tracking-widest"
                                        maxLength="10"
                                        autoComplete="off"
                                    />
                                </div>
                                {pinError && (
                                    <div className="mb-4 text-red-500 text-center text-sm">
                                        {pinError}
                                    </div>
                                )}
                                <button
                                    type="submit"
                                    className="w-full bg-[#f34c02] text-white py-3 px-4 rounded-lg hover:bg-[#d63d02] transition-colors duration-200 font-semibold"
                                >
                                    Access Onboarding
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // Brand data with YouTube URLs and Google Form URLs
    const brandData = {
        'Smash Travels': {
            name: 'Smash Travels',
            youtubeUrl: 'https://youtube.com/shorts/MR9m4-LRrnw',
            formUrl: 'https://forms.gle/NbVoYSM9MoxZfTrt8'
        },
        'Ride Smash': {
            name: 'Ridesmash',
            youtubeUrl: 'https://youtu.be/jsgkCGjE2uU',
            formUrl: ''
        },
         'MailBux': {
            name: 'MailBux',
            youtubeUrl: 'https://youtu.be/Gak1LW4cmsI',
            formUrl: ''
        },
        'Qiimeet': {
            name: 'Qiimeet',
            youtubeUrl: '',
            formUrl: ''
        },
        'SmashWise': {
            name: 'SmashWise',
            youtubeUrl: '',
            formUrl: ''
        },
        'Smash Remit': {
            name: 'Smash Remit',
            youtubeUrl: '',
            formUrl: ''
        },
        'Smash Apartments': {
            name: 'Smash Apartments',
            youtubeUrl: '',
            formUrl: ''
        },
        'Smash Chat': {
            name: 'Smash Chat',
            youtubeUrl: '',
            formUrl: ''
        }
    };

    const handleFilterClick = (filter) => {
        if (filter !== activeFilter) {
            setIsTransitioning(true);
            setTimeout(() => {
                setActiveFilter(filter);
                setTimeout(() => {
                    setIsTransitioning(false);
                }, 50);
            }, 150);
        }
    };

    const getFilteredBrands = () => {
        if (activeFilter === 'All') {
            return Object.keys(brandData);
        }
        return [activeFilter];
    };

    const renderBrandCard = (brandKey) => {
        const brand = brandData[brandKey];
        return (
            <div 
                key={brandKey} 
                className="careers-cards"
                style={{
                    opacity: isTransitioning ? 0 : 1,
                    transform: isTransitioning ? 'translateY(20px)' : 'translateY(0)',
                    transition: 'all 0.3s ease-in-out'
                }}
            >
                <div className="flex">
                    <h3>{brand.name}</h3>
                </div>
                <div>
                    <p>
               At the core of everything we do is a passion to deliver excellence and value powered by a collaborative team that produces result.

As we continue to expand, we are on the lookout for outstanding talents like you who bring heart, skill, and purpose to the team

These short onboarding videos uncover a glimpse into our culture and the product knowledge needed to make you excel in your role and build something truly great together.
                    </p>
                    <a 
                        href={brand.youtubeUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="smashtech-button swipe-button transparent"
                    >
                        Watch On YouTube
                    </a>
                </div>
            </div>
        );
    };

    return (
    <>      
    <Header />    
    <Banner_otherpages title="Onboarding" image={image} />

    <div className="sections pt-0" id="blog">
        {/* Add logout button for convenience */}
        <div className="text-right mb-4">
            <button 
                onClick={() => {
                    setIsAuthenticated(false);
                    sessionStorage.removeItem('onboarding-authenticated');
                    setPinInput('');
                }}
                className="text-sm text-gray-500 hover:text-[#f34c02] transition-colors"
            >
                Logout from Onboarding
            </button>
        </div>

        <div className="flex gap-3 my-[2rem] md:my-[0] md:justify-center w-full items-center overflow-x-auto whitespace-nowrap">
            <button 
                onClick={() => handleFilterClick('All')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'All' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                All
            </button>
            <button 
                onClick={() => handleFilterClick('Smash Travels')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'Smash Travels' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                Smash Travels
            </button>
            <button 
                onClick={() => handleFilterClick('Ride Smash')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'Ride Smash' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                Ride Smash
            </button>

             <button 
                onClick={() => handleFilterClick('MailBux')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'MailBux' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                MailBux
            </button>
            <button 
                onClick={() => handleFilterClick('Qiimeet')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'Qiimeet' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                Qiimeet
            </button>
            <button 
                onClick={() => handleFilterClick('Smash Remit')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'Smash Remit' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                Smash Remit
            </button>
            <button 
                onClick={() => handleFilterClick('SmashWise')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'SmashWise' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                SmashWise
            </button>
            <button 
                onClick={() => handleFilterClick('Smash Apartments')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'Smash Apartments' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                Smash Apartments
            </button>
            <button 
                onClick={() => handleFilterClick('Smash Chat')}
                className={`smashtech-button whitespace-nowrap shrink-0 swipe-button ${activeFilter === 'Smash Chat' ? '' : 'transparent noborder'}`}
                style={{ transition: 'all 0.3s ease' }}
            >
                Smash Chat
            </button>
        </div>
    </div>
    
    <div className="sections section2" id="blog">
        
        <div className="flex flex-col md:flex-row items-start justify-start">
            <div className="c1">

                <div className='mb-3'>
                <h3 className='text-2xl font-semibold text-[#f34c02] !leading-[2rem]'>All Onboarding Videos Avaliable on YouTube</h3>

                </div>
                
                <div style={{
                    minHeight: '200px',
                    transition: 'all 0.3s ease-in-out'
                }}>
                    {getFilteredBrands().map(brandKey => renderBrandCard(brandKey))}
                </div>
            </div>

            <div>

                
                <h2 className='text-2xl font-semibold'>Test</h2><br />
                <h4 className='text-lg'> Read and Answer Carefully</h4><br />
                <div>
                    <div className="careers-cards">                       
                        <div className=" flex flex-col !gap-0 mb-5">
                            <span className="brand-name">Onboarding Test</span>
                            <a href={brandData['Smash Travels']?.formUrl} target="_blank" rel="noopener noreferrer" className="smashtech-button swipe-button">Form</a>
                        </div>
                        <small>All Answer will be received by the H.R. Manager</small>                      
                    </div>
                </div>
            </div>
                
        </div>        
    </div>

    <Map />
    </>
  )
}
export default Blog;